import { z } from 'zod'

import { PASSWORD_VALIDATION } from '@/constants/common.constants'
import { FORM_MESSAGES_MAP } from '@/constants/formMessages.constants'

export const changePasswordFormSchema = z
  .object({
    confirmPassword: z.string().min(1),
    currentPassword: z.string().min(1).regex(PASSWORD_VALIDATION, {
      message: FORM_MESSAGES_MAP.PASSWORD,
    }),
    newPassword: z.string().min(1).regex(PASSWORD_VALIDATION, {
      message: FORM_MESSAGES_MAP.PASSWORD,
    }),
  })
  .superRefine(({ confirmPassword, newPassword }, ctx) => {
    if (confirmPassword !== newPassword) {
      ctx.addIssue({
        code: 'custom',
        message: FORM_MESSAGES_MAP.CONFIRM_PASSWORD,
        path: ['confirmPassword'],
      })
    }
  })
